module.exports = __webpack_public_path__ + "img/order_0.774c98e2.png";